var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Delete_2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.09,2.19H9.77V.83A.33.33,0,0,0,9.45.5H5.53A.33.33,0,0,0,5.2.83V2.19H2.91a.51.51,0,0,0-.51.51v1a.5.5,0,0,0,.46.5,1,1,0,0,0,0,.18v9A1.15,1.15,0,0,0,4,14.5h7a1.15,1.15,0,0,0,1.14-1.14v-9a1,1,0,0,0,0-.18.5.5,0,0,0,.46-.5v-1A.51.51,0,0,0,12.09,2.19ZM5.94,1.62a.27.27,0,0,1,.27-.27H8.83a.27.27,0,0,1,.27.27v.57H5.94Zm2.78,10.6L7.55,10.33,6.39,12.22h-2l2-3.07L4.54,6.33h2l1,1.81,1-1.81h2L8.75,9.18l2,3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.6693ac823ca5c3e244426fd71fe746d9.svg";
export { ForwardRef as ReactComponent };